export default "__VITE_ASSET__DdyhLUX9__"